export default __webpack_public_path__ + "static/media/ui_photo_me.5fd441a7.png";